/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "atlas-20190814103201-hostingbucket-atlasprode",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3pu1lsfvk6x3t.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:ca12e7c9-99d3-4a7e-be58-087845d73c8e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_3TYsgxwJr",
    "aws_user_pools_web_client_id": "7816js52ccuqkbq00k9759uua5",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://olnzpl7p7zewzk7nztxpfxnbcu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://arqe7ui6vd.execute-api.us-east-1.amazonaws.com/atlasprode",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
